module.exports = {

  // Change this to your firebase configuration! (Add Firebase to your web app)
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyDIu5Y7vq4jYmgiVEolyGnn5WQRYhcE--0',
    authDomain: 'staza-prod.firebaseapp.com',
    databaseURL: 'https://staza-prod.firebaseio.com',
    projectId: 'staza-prod',
    storageBucket: 'staza-prod.appspot.com',
    messagingSenderId: '489807438175',
    apiUrl: 'https://us-central1-staza-prod.cloudfunctions.net',
  },

  AUTH0: {
    CLIENT_ID: 'whixMF7UIwcesNrDcQsBishVlBmoep2m',
    DOMAIN: 'staza.auth0.com',
    REDIRECT_URL: window.location.hostname === 'localhost' ? 'http://localhost:3000/callback' : 'https://hub.staza.io/callback',
  },

};



// WEBPACK FOOTER //
// ./src/config/index.js